import TwoFactorForm from "./TwoFactorForm.vue";
export default TwoFactorForm;
